import { useCallback, useRef, useState } from "react";

export const useCommentSectionViewState = () => {
  const [deleteTargetId, setDeleteTargetId] = useState<number | null>(null);
  const [createdCommentTarget, setCreatedCommentTarget] = useState<{
    commentId: number;
  } | null>(null);
  const [
    shouldRevealLoadMoreAfterCollapse,
    setShouldRevealLoadMoreAfterCollapse,
  ] = useState(false);
  const [replyToggleScrollTargetId, setReplyToggleScrollTargetId] = useState<
    number | null
  >(null);
  const loadMoreControlsRef = useRef<HTMLDivElement | null>(null);

  const setCreatedComment = useCallback((commentId: number) => {
    setCreatedCommentTarget({ commentId });
  }, []);

  const clearCreatedCommentTarget = useCallback(() => {
    setCreatedCommentTarget(null);
  }, []);

  const requestRevealLoadMoreAfterCollapse = useCallback(() => {
    setShouldRevealLoadMoreAfterCollapse(true);
  }, []);

  const clearRevealLoadMoreAfterCollapse = useCallback(() => {
    setShouldRevealLoadMoreAfterCollapse(false);
  }, []);

  const requestReplyToggleScroll = useCallback((commentId: number) => {
    setReplyToggleScrollTargetId(commentId);
  }, []);

  const clearReplyToggleScrollTarget = useCallback(() => {
    setReplyToggleScrollTargetId(null);
  }, []);

  return {
    deleteTargetId,
    setDeleteTargetId,
    createdCommentTarget,
    setCreatedComment,
    clearCreatedCommentTarget,
    shouldRevealLoadMoreAfterCollapse,
    requestRevealLoadMoreAfterCollapse,
    clearRevealLoadMoreAfterCollapse,
    replyToggleScrollTargetId,
    requestReplyToggleScroll,
    clearReplyToggleScrollTarget,
    loadMoreControlsRef,
  };
};
